export var TreeBuilder;
(function (TreeBuilder) {
  function buildFromPaths(list, segmentDelimiter = '/') {
    const withPayload = !Array.isArray(list);
    const isMap = withPayload && list instanceof Map;
    const paths = isMap ? Array.from(list.keys()) : withPayload ? Object.keys(list) : list;
    const segmentsList = paths.map(path => {
      const segments = path.split(segmentDelimiter);
      const payload = withPayload ? isMap ? list.get(path) : list[path] : undefined;
      return {
        segments,
        payload
      };
    });
    return buildFromSegments(segmentsList);
  }
  TreeBuilder.buildFromPaths = buildFromPaths;
  function buildFromSegments(list) {
    const tree = [];
    for (let i = 0; i < list.length; i++) {
      createNodeRecursively(list[i].segments, list[i].payload, tree);
    }
    return tree;
  }
  TreeBuilder.buildFromSegments = buildFromSegments;
  function createNodeRecursively(pathSegments, payload, tree, pathFromRoot = '') {
    pathSegments = [...pathSegments];
    const currSegmentName = pathSegments.shift();
    const path = pathFromRoot + '/' + currSegmentName;
    const hasChildren = pathSegments.length > 0;
    const existingIndex = tree.findIndex(e => e.path === path);
    if (existingIndex < 0) {
      tree.push({
        name: currSegmentName,
        path: path,
        payload,
        children: hasChildren ? [] : undefined
      });
      if (pathSegments.length > 0) {
        createNodeRecursively(pathSegments, payload, tree[tree.length - 1].children, pathFromRoot + '/' + currSegmentName);
      }
    } else {
      createNodeRecursively(pathSegments, payload, tree[existingIndex].children, pathFromRoot + '/' + currSegmentName);
    }
  }
  function iterateTree(tree, callback) {
    transformTree(tree, entry => {
      callback(entry);
      return entry;
    });
  }
  TreeBuilder.iterateTree = iterateTree;
  function transformTree(tree, callback) {
    return tree.map(entry => {
      const newEntry = callback({
        ...entry
      });
      if (entry.children) {
        newEntry.children = transformTree(entry.children, callback);
      }
      return newEntry;
    });
  }
  TreeBuilder.transformTree = transformTree;
  function searchTree(tree, callback) {
    const currLevelMatch = tree.find(entry => callback(entry) === true);
    if (currLevelMatch) return currLevelMatch;
    for (const entry of tree) {
      if (!entry.children) continue;
      const childMatch = searchTree(entry.children, callback);
      if (childMatch) return childMatch;
    }
    return null;
  }
  TreeBuilder.searchTree = searchTree;
  function transformToPrimeNgTree(tree, callback) {
    return transformTree(tree, callback);
  }
  TreeBuilder.transformToPrimeNgTree = transformToPrimeNgTree;
})(TreeBuilder || (TreeBuilder = {}));